module.exports = __webpack_public_path__ + "img/sin-chats.8e9feba5.svg";